export enum Entity {
  ADDRESS = 'ADDRESS',
  CONTROL = 'CONTROL',
  EMPLOYEE = 'EMPLOYEE',
  EVENT = 'EVENT',
  EXIGENCES_PER_DAYS = 'EXIGENCES_PER_DAYS',
  GENERATOR = 'GENERATOR',
  LEAVE = 'LEAVE',
  PARAMETER = 'PARAMETER',
  PLANNING = 'PLANNING',
  PRESTATIONTYPE = 'PRESTATIONTYPE',
  REMEMBER = 'REMEMBER',
  ROLE = 'ROLE',
  TEAM = 'TEAM',
}

export const ALL_ENTITY = [
  Entity.ADDRESS,
  Entity.CONTROL,
  Entity.EMPLOYEE,
  Entity.EVENT,
  Entity.EXIGENCES_PER_DAYS,
  Entity.GENERATOR,
  Entity.LEAVE,
  Entity.PARAMETER,
  Entity.PLANNING,
  Entity.PRESTATIONTYPE,
  Entity.REMEMBER,
  Entity.ROLE,
  Entity.TEAM,
];
